import React, { Component } from 'react'
import Store from "app/stores/arrayPgt/statistics"
import { observer, Provider } from "mobx-react"
import statisticsIcon from "app/styles/images/sp/statistics-selected.svg"
import DataHeader from './containers/DataHeader'
import DataTable from './containers/DataTable'
import "./Index.scss"

@observer
export default class Index extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
  }
  render() {
    return (
      <Provider store={this.store}>
        <div className="statistics-page pgd">
          <h2 className="page-title">
            <img alt="" src={statisticsIcon} />统计
          </h2>
          <div className="clearfix wrapper-box-first">
            <DataHeader />
          </div>
          <div>
            <DataTable store={this.store} />
          </div>
        </div>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/statistics/index.js